import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

import { useStyles } from "../UserFees.css";

class FeeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [{ name: "S.N." }, { name: "Particulars" }, { name: "Price" }],
    };
  }

  render() {
    const { classes, feeData, total, paid } = this.props;
    return (
      <TableContainer>
        <Table className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              {this.state.column.map((column, index) => (
                <TableCell
                  key={index}
                  align="center"
                  className={classes.tableStyle}
                  style={{ fontWeight: "bold" }}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {feeData.map((fee, index) => (
              <TableRow key={index}>
                <TableCell
                  align="center"
                  className={classes.tableStyle}
                  style={{ width: "10%" }}
                >
                  {index + 1}
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.tableStyle}
                  style={{ width: "60%" }}
                >
                  {fee.feeTypeName}
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.tableStyle}
                  style={{ width: "30%" }}
                >
                  Rs. {fee.price} /-
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell
                align="center"
                colSpan={2}
                className={classes.tableStyle}
              >
                Total
              </TableCell>
              <TableCell align="center" className={classes.tableStyle}>
                Rs. {total} /-
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                align="center"
                colSpan={2}
                className={classes.tableStyle}
              >
                Paid
              </TableCell>
              <TableCell align="center" className={classes.tableStyle}>
                Rs. {paid} /-
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                align="center"
                colSpan={2}
                className={classes.tableStyle}
              >
                Due
              </TableCell>
              <TableCell align="center" className={classes.tableStyle}>
                Rs.
                {total - paid} /-
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default withStyles(useStyles)(FeeDetails);
